import IBaseRespone from '../../model/respone/IBaseRespone';
import httpClient from '../httpService';
import {
    TS_HoSoThiSinh_ViewModel,
    TS_TongHopThiSinhDanhKyTheoMon,
    TS_TongHopThiSinhDanhKyTheoNganh
} from './HoSoThiSinhModels';

const HoSoThiSinhAPIUrl = '/api/hosothisinh';
export const HoSoThiSinhService = {
    selectByDot: async (ID_dot_tuyen: number): Promise<TS_HoSoThiSinh_ViewModel[]> => {
        const res = await httpClient.get(`${HoSoThiSinhAPIUrl}/SelectByDot?ID_dot_tuyen=${ID_dot_tuyen}`);
        if ((res as any)?.is_success === false || res?.data?.is_success === false) throw Error((res as any)?.message || res?.data?.message || 'Không tải được danh sách thí sinh theo đợt tuyển sinh.');
        if (!Array.isArray(res?.data?.data)) throw Error('Dữ liệu thí sinh không hợp lệ.');
        return res.data.data;
    },
    selectByDotHocBSKT: async (idDotHocBSKT: number): Promise<TS_HoSoThiSinh_ViewModel[]> => {
        const res = await httpClient.get(`${HoSoThiSinhAPIUrl}/SelectByDotHoc?ID_dot_hoc=${idDotHocBSKT}`);
        if ((res as any)?.is_success === false || res?.data?.is_success === false) throw Error((res as any)?.message || res?.data?.message || 'Không tải được danh sách thí sinh.');
        if (!Array.isArray(res?.data?.data)) throw Error('Dữ liệu thí sinh không hợp lệ.');
        return res.data.data;
    },

    tongHopTheoMon: async (ID_dot_tuyen: number): Promise<IBaseRespone<TS_TongHopThiSinhDanhKyTheoMon[]>> => {
        const res = await httpClient.get(`${HoSoThiSinhAPIUrl}/TongHopTheoMon?ID_dot_tuyen=${ID_dot_tuyen}`);
        return res.data;
    },
    tongHopTheoNganh: async (ID_dot_tuyen: number): Promise<IBaseRespone<TS_TongHopThiSinhDanhKyTheoNganh[]>> => {
        const res = await httpClient.get(`${HoSoThiSinhAPIUrl}/TongHopTheoNganh?ID_dot_tuyen=${ID_dot_tuyen}`);
        return res.data;
    }
};
